import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";

const equipmentPropertyValue = new AthubRestResource({server: DCIM_SERVER, resource: 'equipment-property-value'});

export default equipmentPropertyValue;
